// extracted by mini-css-extract-plugin
module.exports = {"card":"card--EDnyz","box":"box--cNDzS","left":"left--zLdMo","right":"right--kZz7E","bold":"bold--H5unI","active":"active--6BIMB","disabled":"disabled--wvTv0"};